export default {
  "1": "广告",
  "2": "在线人数",
  "3": "最新投稿",
  "4": "更多",
  "5": "推广",
  "6": "综合得分",
  "7": "当前共有",
  "8": "个在线直播",
  "9": "直播排行",
  "10": "关注的主播",
  "11": "为你推荐",
  "12": "特别推荐",
  "13": "番剧动态",
  "14": "国产原创相关",
  "15": "新番时间表",
  "16": "最新",
  "17": "周一",
  "18": "周二",
  "19": "周三",
  "20": "周四",
  "21": "周五",
  "22": "周六",
  "23": "周日",
  "24": "返回<br />旧版",
  "25": "换一换",
  "26": "排行榜",
  "27": "播放",
  "28": "游戏赛事",
  "29": "观看列表",
  // 漫画
  "30": "人气推荐",
  "31": "免费漫画推荐",
  "32": "下载",
  "33": "领券免费看",
  "34": "月票",
  "35": "应援",
  "36": "飙升",
  "37": "试用反馈",
  "38": "联系客服",

  
}